module.exports = __webpack_public_path__ + "img/t1-7.88830271.png";